<template>
    <div class="profile__image">
        <span v-if="!profileImage">{{firstLetter}}</span>
        <img :src="profileImage" v-else alt="">
        <div v-if="ownProfile">
            <input type="file" class="inputfile"  @change="createformData($event.target.files)" />
            <i class="material-icons">mode_edit</i>  
        </div>

    </div>
</template>

<script>
    export default {
        props: ['user', 'disabled'],
        computed:{
            firstLetter(){
                if(this.profile && this.profile.first_name !== undefined){
                    return this.profile.first_name.charAt(0);
                }
                
                return 'Z';
            },
            profile(){
               
                if(this.user !== undefined && Object.keys(this.user).length > 0){
                   return this.user;
                }
                else if(this.$store.state.user.data !== null){
                    return this.$store.state.user.data;
                } else{
                    return null;
                }
            },
            profileImage(){
                // SET PROFILE
                if(this.profile && this.profile.avatar && this.profile.avatar.length > 0){
                    return this.profile.avatar[0].public_thumbnail;
                }else{
                    return false;
                }
            },
            ownProfile(){

                if(this.$route.name === 'useredit' && !this.disabled){
                    return true;
                }
                return false;
            }
        },
        methods: {
            createformData(fileList){
                
                if (!fileList || fileList.length) {
                
                    this.fileName = fileList[0].name;

                    // handle file changes
                    const formData = new FormData();
                
                    // append the files to FormData
                    Array
                        .from(Array(fileList.length).keys())
                        .map(x => {
                            formData.append('avatar', fileList[x], fileList[x].name);
                        });

                    // save it
                    this.updateImage(formData);
                }
                

            },
            async updateImage(formData){
                try {
                    let user = await this.$axios.post('/users/avatar', formData);
                    this.$store.commit('user/SET_USER', user.data.data);
                } catch (e) {
                    this.displayErrors(e.response.data.errors);
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import '~styles/_vars.scss';
    .profile__image{
        height: 4.5em;
        width: 4.5em;
        border-radius: 50%;
        border: 2px solid $white;
        
        display: inline-flex;
        justify-content: center;
        align-content: center;

        text-align: center;
        position: relative;
        overflow: hidden;
        input[type="file"]{
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            opacity: 0;
            cursor: pointer;
        }
        span {
            font-size: 30px;
            color: #FFFFFF;
            background-color: $black;
            height: 100%;
            width: 100%;
            display: flex;
            justify-content: center;
            align-content: center;
            align-items: center;
        }
        img{
            width: 100%;
            height: auto;
        }
        i.material-icons{
            position: absolute;
            color: #FFF;
            background-color: rgba(0,0,0,0.2);
            height: 100%;
            width: 100%;
            top: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 30px;

            display: none;
        }

        &:hover{
            i.material-icons{
                display: flex;
                pointer-events: none;

                &::selection{
                    background: transparent;
                }
                
            }
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/profile-image.vue